import { render, staticRenderFns } from "./updatePWD.vue?vue&type=template&id=2420abcd&scoped=true"
import script from "./updatePWD.vue?vue&type=script&lang=js"
export * from "./updatePWD.vue?vue&type=script&lang=js"
import style0 from "./updatePWD.vue?vue&type=style&index=0&id=2420abcd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420abcd",
  null
  
)

export default component.exports